import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-31-priyans-murarka-guest.webp";
import ThumbImg from "../../assets/images/conversations/031.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: eu-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .eu-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .eu-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .eu-hero { padding-top: 60px; padding-bottom: 60px; }
  .eu-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .eu-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .eu-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .eu-hero__title.eu-visible { opacity: 1; transform: translateY(0); }
  .eu-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .eu-hero__spotify.eu-visible { opacity: 1; transform: translateY(0); }
  .eu-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .eu-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .eu-hero__right.eu-visible { opacity: 1; transform: translateY(0); }

  .eu-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .eu-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .eu-yt-thumb:hover img { opacity: 0.85; }
  .eu-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .eu-yt-thumb__play img { width: 40px; height: 44px; }
  .eu-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .eu-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .eu-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .eu-body.eu-visible { opacity: 1; transform: translateY(0); }
  .eu-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .eu-body__para:last-child { margin-bottom: 0; }

  .eu-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .eu-guest.eu-visible { opacity: 1; transform: translateY(0); }
  .eu-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .eu-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .eu-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .eu-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .eu-inner { padding-left: 32px; padding-right: 32px; }
    .eu-hero { padding-top: 32px; padding-bottom: 48px; }
    .eu-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .eu-hero__title { font-size: 24px; }
    .eu-hero__left { gap: 16px; }
    .eu-guest__title { font-size: 24px; margin-bottom: 24px; }
    .eu-guest__photo-bg { width: 260px; height: 300px; }
    .eu-guest__name { font-size: 24px; margin-top: 18px; }
    .eu-body__para { font-size: 14px; margin-bottom: 12px; }
    .eu-body { padding-bottom: 48px; }
    .eu-guest { padding-bottom: 48px; }
    .eu-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .eu-inner { padding-left: 16px; padding-right: 16px; }
    .eu-hero { padding-top: 51px; padding-bottom: 30px; }
    .eu-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .eu-hero__left { gap: 30px; }
    .eu-hero__title { font-size: 30px; }
    .eu-body__para { font-size: 16px; margin-bottom: 10px; }
    .eu-guest__title { font-size: 30px; margin-bottom: 20px; }
    .eu-guest__photo-bg { width: 100%; height: 386px; }
    .eu-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .eu-body { padding-bottom: 30px; }
    .eu-guest { padding-bottom: 30px; }
    .eu-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("eu-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP31_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="eu-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 31 EV Super User"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="eu-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 31 EV Super User thumbnail" />
      <div className="eu-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="eu-hero">
      <div className="eu-inner">
        <div className="eu-hero__grid">
          <div className="eu-hero__left">
            <h1 ref={titleRef} className="eu-hero__title">
              EP 31 | Driving into the Future: A Conversation with an EV Super User
            </h1>
            <div ref={spotifyRef} className="eu-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/7shEiihA3VcWEK27ykD8KY?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 31 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="eu-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="eu-body">
      <div className="eu-inner">
        <p className="eu-body__para">
          Over the last two years of this program, we have had discussions with industry leaders and key protagonists from the electric and clean mobility sector in India. We have gained insightful knowledge about what makes this industry tick and why some companies are successful while others struggle to find a breakthrough. Often, there have been golden nuggets on how they continued to find success in a market full of uncertainty and adventure in these early years of energy transition. During our deep dives in this program, we occasionally have special moments like today where we get to chat with a super user of EVs in India. We uncover the perspectives of the most important person in the entire electric mobility value chain – the driver of the vehicle. Today, we had a conversation with Priyans Muraka, an EV superuser who owns an MG ZS EV and has completed more than 20,000 KMs using it on work trips across India. We discussed why he chose the MG, his experience with not just fast chargers, but also the various charge point operators, and the pain points of early adopting EV users. Priyans also has his own blog called Experience with EVs where he writes about using EVs across India and brought a wealth of information for CPOs and EV car manufacturers. Experience With EVs – http://expwithevs.in/
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="eu-guest">
      <div className="eu-inner">
        <h2 className="eu-guest__title">Our Guest</h2>
        <div>
          <div className="eu-guest__photo-bg">
            <img src={GuestImg} alt="Priyans Murarka" />
          </div>
          <p className="eu-guest__name">Priyans MURARKA</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep31EVSuperUser() {
  return (
    <>
      <style>{CSS}</style>
      <div className="eu-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}